import {Provider} from '@angular/core';

import {ListBanksUseCase} from '@features/setting/application/use_cases/list-banks/list-banks.use-case';

import {
  ListBanksHttpProvider
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.provider';

export const ListBanksUseCaseProvider: Provider[] = [
  ...ListBanksHttpProvider,
  ListBanksUseCase
];
